import { cn } from "../ui/utils";

export type AnnouncementRichTextProps = {
  html: string;
  className?: string;
};

const richTextClassName = cn(
  "text-slate-700 dark:text-slate-300 text-sm leading-relaxed",
  "[&_p]:mb-4 [&_p:last-child]:mb-0",
  "[&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-slate-900 [&_h2]:dark:text-white [&_h2]:mb-3 [&_h2]:mt-6 [&_h2:first-child]:mt-0",
  "[&_h3]:text-base [&_h3]:font-bold [&_h3]:text-slate-900 [&_h3]:dark:text-white [&_h3]:mb-2 [&_h3]:mt-4",
  "[&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-4 [&_ul]:space-y-1",
  "[&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:mb-4 [&_ol]:space-y-1",
  "[&_li]:text-slate-600 [&_li]:dark:text-slate-400",
  "[&_a]:text-emerald-600 [&_a]:dark:text-[#00FFA3] [&_a]:underline [&_a]:underline-offset-2",
  "[&_strong]:font-bold [&_strong]:text-slate-900 [&_strong]:dark:text-white",
  "[&_code]:font-mono [&_code]:text-xs [&_code]:bg-slate-100 [&_code]:dark:bg-[#1a1d1f] [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded",
  "[&_img]:max-w-full [&_img]:h-auto [&_img]:rounded-xl [&_img]:my-4 [&_img]:border [&_img]:border-slate-200 [&_img]:dark:border-[#D2F0E1]/10",
  "[&_blockquote]:border-l-4 [&_blockquote]:border-emerald-500 [&_blockquote]:dark:border-[#00FFA3]/50 [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:text-slate-500 [&_blockquote]:dark:text-slate-400 [&_blockquote]:my-4"
);

export function AnnouncementRichText({ html, className }: AnnouncementRichTextProps) {
  return (
    <div
      className={cn(richTextClassName, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
